import Vue from 'vue';
import ConsumerAccountDetails from '@/views/ConsumerAccountDetails.vue';
import JobExecutions from '@/views/JobExecutions.vue';
import Reports from '@/views/Reports.vue';
import FileLoadHistory from '@/views/FileLoadHistory.vue';
import ImportSummary from '@/views/ImportSummary.vue';
import LegacyRedirect from '@/views/LegacyRedirect.vue';
import IncomingRedirect from '@/views/IncomingRedirect.vue';
import AuditMessages from '@/views/AuditMessages.vue';
import QualificationsAndRewardsSummary from '@/views/QualificationsAndRewardsSummary.vue';
import RecompSummary from '@/views/RecompSummary.vue';
import QualificationOverride from '@/views/QualificationOverride.vue';
import RewardsValidation from '@/views/RewardsValidation.vue';
import { fiLockDown, appModeCheck } from '@kasasa/fbase-components/lib';
import '@/plugins/axios';

import App from '@/App.vue';
import store from '@/store';
import router from './router';
import vuetify from './plugins/vuetify';

// use following if you want /:clientId lockdown
router.beforeEach(fiLockDown(store));
router.beforeEach(appModeCheck(store));

Vue.config.productionTip = false;

// handle page reloads
const app: Vue = new Vue({
  el: '#app',
  vuetify,
  store,
  router,
  components: {
    ConsumerAccountDetails,
    JobExecutions,
    Reports,
    FileLoadHistory,
    LegacyRedirect,
    IncomingRedirect,
    AuditMessages,
    ImportSummary,
    QualificationsAndRewardsSummary,
    QualificationOverride,
    RewardsValidation,
    RecompSummary,
  },
  render: h => h(App),
});
